import { useMobileResponsive } from "@src/app/hooks/useDeviceType";
import IframeResizer from "iframe-resizer-react";
export type IframeWrapperAttr = {
  className?: string;
};

export type IframeProps = {
  src: string;
  height?: string;
  width?: string;
  title?: string;
  className?: string;
  allowFullScreen?: boolean;
  addWrapper?: boolean;
  wrapperAttr?: IframeWrapperAttr;
};

export default function Iframe({
  src,
  height = "642",
  width = "620",
  title = "#NoTapis",
  className,
  allowFullScreen = false,
  addWrapper = false,
  wrapperAttr = {},
}: IframeProps) {
  const { isMobile, mounted } = useMobileResponsive();

  const iframe = (
    <>
      <div className="justify-center">
        <IframeResizer
          className={className}
          src={src}
          checkOrigin={false}
          heightCalculationMethod={mounted && isMobile ? "bodyScroll" : "max"}
          title={title}
          allowFullScreen={allowFullScreen}
          style={{
            width: width,
            minWidth: mounted && isMobile ? "95%" : "100%",
            border: "none",
            minHeight: mounted && isMobile ? "1024px" : height + "px",
          }}
        />
      </div>
    </>
  );

  return addWrapper ? (
    <div className={wrapperAttr.className}>{iframe}</div>
  ) : (
    iframe
  );
}
